/*
 * Configuración base de comprobantes
 * Describe el comportamiento inicial y reglas de negocio
 */

export const OPERACION = {
  VENTA: "VENTA",
  COMPRA: "COMPRA"
};

export const DOCUMENTO = {
  FACTURA: "FC",
  PEDIDO: "PE",
  REMITO: "RE",
  NOTA_CREDITO: "NC",
  NOTA_DEBITO: "ND"
};

export const COMPROBANTES = {
  FACTURA_VENTA: {
    operacion: OPERACION.VENTA,
    documento: DOCUMENTO.FACTURA,

    withIva: true,
    controlaStock: true,
    impactaStock: true,

    moneda: "ARS",
    tipoRedondeo: "entero",
    
    // Indica si el usuario puede cambiar entre Neto/Final en la UI
    permiteCambiarVistaIva: true, 
    // Por defecto, las facturas suelen empezar en modo Neto (false) para empresas
    precioVentaManual: false 
  },

  PEDIDO_VENTA: {
    operacion: OPERACION.VENTA,
    documento: DOCUMENTO.PEDIDO,

    withIva: true,
    controlaStock: false,
    impactaStock: false,

    moneda: "ARS",
    tipoRedondeo: "entero",

    // En Pedidos, casi siempre se vende a precio final de lista
    permiteCambiarVistaIva: false, 
    precioVentaManual: true 
  },

  REMITO_VENTA: {
    operacion: OPERACION.VENTA,
    documento: DOCUMENTO.REMITO,

    withIva: false, // El remito es un documento de traslado, no fiscal
    controlaStock: true,
    impactaStock: true,

    moneda: "ARS",
    tipoRedondeo: "entero",
    
    permiteCambiarVistaIva: false,
    precioVentaManual: true 
  },

  FACTURA_COMPRA: {
    operacion: OPERACION.COMPRA,
    documento: DOCUMENTO.FACTURA,

    withIva: true,
    controlaStock: true,
    impactaStock: true,

    moneda: "ARS",
    tipoRedondeo: "decimales", // Las compras necesitan precisión centavada
    
    // En compras siempre se carga el neto y se discrimina el IVA
    permiteCambiarVistaIva: false,
    precioVentaManual: false 
  },

  PEDIDO_COMPRA: {
    operacion: OPERACION.COMPRA,
    documento: DOCUMENTO.PEDIDO,

    withIva: true,
    controlaStock: false,
    impactaStock: false,

    moneda: "ARS",
    tipoRedondeo: "decimales",
    
    permiteCambiarVistaIva: false,
    precioVentaManual: false
  }
};